export const ALL_CURRENCIES = [
  { id: "AED", name: "UAE Dirham" },
  { id: "AFN", name: "Afghan Afghani" },
  { id: "ALL", name: "Albanian Lek" },
  { id: "AMD", name: "Armenian Dram" },
  { id: "ANG", name: "Netherlands Antillean Guilder" },
  { id: "AOA", name: "Angolan Kwanza" },
  { id: "ARS", name: "Argentine Peso" },
  { id: "AUD", name: "Australian Dollar" },
  { id: "AWG", name: "Aruban Florin" },
  { id: "AZN", name: "Azerbaijani Manat" },
  { id: "BAM", name: "Bosnia-Herzegovina Convertible Mark" },
  { id: "BBD", name: "Barbadian Dollar" },
  { id: "BDT", name: "Bangladeshi Taka" },
  { id: "BGN", name: "Bulgarian Lev" },
  { id: "BHD", name: "Bahraini Dinar" },
  { id: "BIF", name: "Burundian Franc" },
  { id: "BMD", name: "Bermudian Dollar" },
  { id: "BND", name: "Brunei Dollar" },
  { id: "BOB", name: "Bolivian Boliviano" },
  { id: "BRL", name: "Brazilian Real" },
  { id: "BSD", name: "Bahamian Dollar" },
  { id: "BTC", name: "Bitcoin" },
  { id: "BTN", name: "Bhutanese Ngultrum" },
  { id: "BWP", name: "Botswana Pula" },
  { id: "BYN", name: "Belarusian Ruble" },
  { id: "BZD", name: "Belize Dollar" },
  { id: "CAD", name: "Canadian Dollar" },
  { id: "CDF", name: "Congolese Franc" },
  { id: "CHF", name: "Swiss Franc" },
  { id: "CLF", name: "Chilean Unit of Account (UF)" },
  { id: "CLP", name: "Chilean Peso" },
  { id: "CNH", name: "Chinese Yuan (offshore)" },
  { id: "CNY", name: "Chinese Yuan" },
  { id: "COP", name: "Colombian Peso" },
  { id: "CRC", name: "Costa Rican Colón" },
  { id: "CUC", name: "Cuban Convertible Peso" },
  { id: "CUP", name: "Cuban Peso" },
  { id: "CVE", name: "Cape Verdean Escudo" },
  { id: "CZK", name: "Czech Koruna" },
  { id: "DJF", name: "Djiboutian Franc" },
  { id: "DKK", name: "Danish Krone" },
  { id: "DOP", name: "Dominican Peso" },
  { id: "DZD", name: "Algerian Dinar" },
  { id: "EGP", name: "Egyptian Pound" },
  { id: "ERN", name: "Eritrean Nakfa" },
  { id: "ETB", name: "Ethiopian Birr" },
  { id: "EUR", name: "Euro" },
  { id: "FJD", name: "Fijian Dollar" },
  { id: "FKP", name: "Falkland Islands Pound" },
  { id: "GBP", name: "British Pound" },
  { id: "GEL", name: "Georgian Lari" },
  { id: "GGP", name: "Guernsey Pound" },
  { id: "GHS", name: "Ghanaian Cedi" },
  { id: "GIP", name: "Gibraltar Pound" },
  { id: "GMD", name: "Gambian Dalasi" },
  { id: "GNF", name: "Guinean Franc" },
  { id: "GTQ", name: "Guatemalan Quetzal" },
  { id: "GYD", name: "Guyanese Dollar" },
  { id: "HKD", name: "Hong Kong Dollar" },
  { id: "HNL", name: "Honduran Lempira" },
  { id: "HRK", name: "Croatian Kuna" },
  { id: "HTG", name: "Haitian Gourde" },
  { id: "HUF", name: "Hungarian Forint" },
  { id: "IDR", name: "Indonesian Rupiah" },
  { id: "ILS", name: "Israeli New Shekel" },
  { id: "IMP", name: "Isle of Man Pound" },
  { id: "INR", name: "Indian Rupee" },
  { id: "IQD", name: "Iraqi Dinar" },
  { id: "IRR", name: "Iranian Rial" },
  { id: "ISK", name: "Icelandic Króna" },
  { id: "JEP", name: "Jersey Pound" },
  { id: "JMD", name: "Jamaican Dollar" },
  { id: "JOD", name: "Jordanian Dinar" },
  { id: "JPY", name: "Japanese Yen" },
  { id: "KES", name: "Kenyan Shilling" },
  { id: "KGS", name: "Kyrgyzstani Som" },
  { id: "KHR", name: "Cambodian Riel" },
  { id: "KMF", name: "Comorian Franc" },
  { id: "KPW", name: "North Korean Won" },
  { id: "KRW", name: "South Korean Won" },
  { id: "KWD", name: "Kuwaiti Dinar" },
  { id: "KYD", name: "Cayman Islands Dollar" },
  { id: "KZT", name: "Kazakhstani Tenge" },
  { id: "LAK", name: "Lao Kip" },
  { id: "LBP", name: "Lebanese Pound" },
  { id: "LKR", name: "Sri Lankan Rupee" },
  { id: "LRD", name: "Liberian Dollar" },
  { id: "LSL", name: "Lesotho Loti" },
  { id: "LYD", name: "Libyan Dinar" },
  { id: "MAD", name: "Moroccan Dirham" },
  { id: "MDL", name: "Moldovan Leu" },
  { id: "MGA", name: "Malagasy Ariary" },
  { id: "MKD", name: "Macedonian Denar" },
  { id: "MMK", name: "Myanmar Kyat" },
  { id: "MNT", name: "Mongolian Tögrög" },
  { id: "MOP", name: "Macanese Pataca" },
  { id: "MRU", name: "Mauritanian Ouguiya" },
  { id: "MUR", name: "Mauritian Rupee" },
  { id: "MVR", name: "Maldivian Rufiyaa" },
  { id: "MWK", name: "Malawian Kwacha" },
  { id: "MXN", name: "Mexican Peso" },
  { id: "MYR", name: "Malaysian Ringgit" },
  { id: "MZN", name: "Mozambican Metical" },
  { id: "NAD", name: "Namibian Dollar" },
  { id: "NGN", name: "Nigerian Naira" },
  { id: "NIO", name: "Nicaraguan Córdoba" },
  { id: "NOK", name: "Norwegian Krone" },
  { id: "NPR", name: "Nepalese Rupee" },
  { id: "NZD", name: "New Zealand Dollar" },
  { id: "OMR", name: "Omani Rial" },
  { id: "PAB", name: "Panamanian Balboa" },
  { id: "PEN", name: "Peruvian Sol" },
  { id: "PGK", name: "Papua New Guinean Kina" },
  { id: "PHP", name: "Philippine Peso" },
  { id: "PKR", name: "Pakistani Rupee" },
  { id: "PLN", name: "Polish Złoty" },
  { id: "PYG", name: "Paraguayan Guaraní" },
  { id: "QAR", name: "Qatari Riyal" },
  { id: "RON", name: "Romanian Leu" },
  { id: "RSD", name: "Serbian Dinar" },
  { id: "RUB", name: "Russian Ruble" },
  { id: "RWF", name: "Rwandan Franc" },
  { id: "SAR", name: "Saudi Riyal" },
  { id: "SBD", name: "Solomon Islands Dollar" },
  { id: "SCR", name: "Seychellois Rupee" },
  { id: "SDG", name: "Sudanese Pound" },
  { id: "SEK", name: "Swedish Krona" },
  { id: "SGD", name: "Singapore Dollar" },
  { id: "SHP", name: "St Helena Pound" },
  { id: "SLE", name: "Sierra Leonean Leone" },
  { id: "SLL", name: "Sierra Leonean Leone (old)" },
  { id: "SOS", name: "Somali Shilling" },
  { id: "SRD", name: "Surinamese Dollar" },
  { id: "SSP", name: "South Sudanese Pound" },
  { id: "STD", name: "São Tomé and Príncipe Dobra (old)" },
  { id: "STN", name: "São Tomé and Príncipe Dobra" },
  { id: "SVC", name: "Salvadoran Colón" },
  { id: "SYP", name: "Syrian Pound" },
  { id: "SZL", name: "Swazi Lilangeni" },
  { id: "THB", name: "Thai Baht" },
  { id: "TJS", name: "Tajikistani Somoni" },
  { id: "TMT", name: "Turkmenistan Manat" },
  { id: "TND", name: "Tunisian Dinar" },
  { id: "TOP", name: "Tongan Paʻanga" },
  { id: "TRY", name: "Turkish Lira" },
  { id: "TTD", name: "Trinidad & Tobago Dollar" },
  { id: "TWD", name: "New Taiwan Dollar" },
  { id: "TZS", name: "Tanzanian Shilling" },
  { id: "UAH", name: "Ukrainian Hryvnia" },
  { id: "UGX", name: "Ugandan Shilling" },
  { id: "USD", name: "US Dollar" },
  { id: "UYU", name: "Uruguayan Peso" },
  { id: "UZS", name: "Uzbekistani Soʻm" },
  { id: "VES", name: "Venezuelan Bolívar Soberano" },
  { id: "VND", name: "Vietnamese đồng" },
  { id: "VUV", name: "Vanuatu Vatu" },
  { id: "WST", name: "Samoan Tālā" },
  { id: "XAF", name: "Central African CFA franc" },
  { id: "XAG", name: "Silver (troy ounce)" },
  { id: "XAU", name: "Gold (troy ounce)" },
  { id: "XCD", name: "East Caribbean Dollar" },
  { id: "XCG", name: "Community Gold" },
  { id: "XDR", name: "Special Drawing Rights" },
  { id: "XOF", name: "West African CFA franc" },
  { id: "XPD", name: "Palladium (troy ounce)" },
  { id: "XPF", name: "CFP Franc" },
  { id: "XPT", name: "Platinum (troy ounce)" },
  { id: "YER", name: "Yemeni Rial" },
  { id: "ZAR", name: "South African Rand" },
  { id: "ZMW", name: "Zambian Kwacha" },
  { id: "ZWG", name: "Zimbabwe Gold" },
  { id: "ZWL", name: "Zimbabwean dollar" },
];
